export default __webpack_public_path__ + "static/torch-2ae3c6e28309bb40cb1225f0cc75e7eb.png";